define("settings/utils/handle-settings-error", ["exports", "shared/utils/build-error-message"], function (_exports, _buildErrorMessage) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71f0,"shared/utils/build-error-message"eaimeta@70e063a35619d71f
  /**
   * Builds an error flash message based on the provided error.
   * This flash message can optionally be used by the caller for display purposes.
   * The original error is also passed back to the caller.
   *
   * @method handleError
   * @param {Error} error An Error object
   * @param {String} translationPath The path to look up when finding translation
   * @param {Service} intl The intl service
   *
   * @returns {Object<alert, error>} An Object containing a formatted alert, and the original error.
   */
  const handleSettingsError = (error, translationPath, intl) => ({
    alert: {
      type: 'warning',
      message: (0, _buildErrorMessage.default)(intl, error, `${translationPath}.error.message`),
      title: intl.t(`${translationPath}.error.title`),
      timeout: 5000
    },
    error
  });
  var _default = _exports.default = handleSettingsError;
});